import {
	ADD_CUSTOM_BODY,
	CLEAR_PROFILE_DATA,
	CREATE_CUSTOM,
	CREATE_DUPLICATE_SECTION,
	CREATE_INDEPENDENCE_FORM,
	DELETE_FORM_BODY,
	DELETE_HEADER,
	DELETE_SECTION,
	EDIT_BODY,
	EDIT_HEADER,
	EDIT_SECTION,
	GET_BODY_GUIDANCES,
	GET_FORM_BODIES_AFTER_RESPONSE,
	GET_FORM_BODIES_BY_BODYTYPEID,
	GET_FORM_BODIES_BY_SECTIONID,
	GET_FORM_DATA,
	GET_FORM_PROFILE_DATA_BY_ID,
	OVERWRITE_FORM,
	SUBMIT_INDEPENDENCE,
	SUBMIT_INDEPENDENCE_ACTION,
	SUBMIT_INDEPENDENCE_TEMPLATE,
	SUBMIT_PROFILE,
	UPDATE_BODY_FREE_TEXT,
	UPDATE_BODY_ON_CONFLICT,
	UPDATE_BODY_RELATED_COUNT,
	UPDATE_FORM_BODY_DISPLAY_DATA_ONLY,
	UPDATE_FORM_BODY_RELATED_DEFICIENCY,
	UPDATE_FORM_BODY_RELATEOBJECTS_AFTER_RESPONSE,
	UPDATE_FORM_BODY_RESPONSE,
	UPDATE_FORM_BODY_RESPONSE_NO_STORE_UPDATE,
	UPDATE_FORM_PROFILE_RESPONSE,
	UPDATE_FORMBODY_RISKFACTORS,
	UPDATE_RICH_TEXT_BODY
} from '../actiontypes';
import env from '../../util/env';
import {documentTypes, OperationTypes, serviceURL, promiseAreas} from '../../util/uiconstants';
import {submitIndependenceTemplateUrl} from '../apiUrls';

import {API_RESOURCES, createApiReadAction} from '../../util/api';
import Env from '../../util/env';

export const getFormData = (url, params = {}) => {
	return {
		type: GET_FORM_DATA,
		meta: {
			api: {
				url,
				method: 'GET'
			}
		},
		...params
	};
};

export const updateFormDataAfterBodyResponse = (formData) => {
	return {
		type: GET_FORM_DATA,
		response: formData
	};
};

export const getFormProfileDataById = (engagementId, formId) => {
	return createApiReadAction(
		GET_FORM_PROFILE_DATA_BY_ID,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.FORMS.FORMS]: formId
		},
		{expand: 'profile'}
	);
};

export const updateFormProfileResponse = (url, resource) => {
	return {
		type: UPDATE_FORM_PROFILE_RESPONSE,
		meta: {
			api: {
				url,
				method: 'PUT',
				data: resource
			}
		}
	};
};

export const getFormBodiesBySectionId = (url) => {
	return {
		type: GET_FORM_BODIES_BY_SECTIONID,
		resolve: true,
		meta: {
			api: {
				url,
				method: 'GET'
			}
		}
	};
};

export const getFormBodiesByBodyTypeId = (engagementId, documentId, headerId, sectionId, queryParams) => {
	return createApiReadAction(
		GET_FORM_BODIES_BY_BODYTYPEID,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.FORMS.FORMS]: documentId,
			[API_RESOURCES.FORMS.HEADERS]: headerId,
			[API_RESOURCES.FORMS.SECTIONS]: sectionId,
			[API_RESOURCES.FORMS.BODIES]: undefined
		},
		queryParams
	);
};

export const updateFormBodyResponseNoSaga = (url, resource) => {
	return {
		type: UPDATE_FORM_BODY_RESPONSE,
		resolve: true,
		meta: {
			api: {
				url,
				method: 'PUT',
				data: resource
			}
		}
	};
};

export const updateFormBodyResponse = (url, resource) => {
	/*if (resource.bodyTypeId !== formBodyType.TextResponse && resource.bodyTypeId !== formBodyType.InlineRichText) {
		Utility.increaseSaveBodyCount();
	}
	return {type: types.UPDATE_FORM_BODY_RESPONSE_SAGA, url: url, resource: resource};*/
	return {
		type: UPDATE_FORM_BODY_RESPONSE,
		resolve: true,
		meta: {
			api: {
				url,
				method: 'PUT',
				data: resource
			}
		}
	};
};

export const getFormBodiesAfterProcessingResponse = (formBodyData, sectionId) => {
	return {
		type: GET_FORM_BODIES_AFTER_RESPONSE,
		response: formBodyData,
		sectionId: sectionId
	};
};

export const updateFormBodyResponseNoStoreUpdate = (url, payload) => {
	return {
		type: UPDATE_FORM_BODY_RESPONSE_NO_STORE_UPDATE,
		resolve: true,
		meta: {
			api: {
				url,
				method: 'PUT',
				data: payload
			}
		}
	};
};

export const deleteFormBody = (url, bodyId) => {
	return {
		type: DELETE_FORM_BODY,
		meta: {
			api: {
				url,
				method: 'DELETE'
			}
		},
		bodyId: bodyId
	};
};

export const duplicateSection = (url, data, sectionId) => {
	return {
		type: CREATE_DUPLICATE_SECTION,
		meta: {
			api: {
				url: url,
				method: 'POST',
				data: data
			}
		},
		sectionId: sectionId
	};
};

export const deleteSection = (url, data) => {
	return {
		type: DELETE_SECTION,
		meta: {
			api: {
				url: url,
				method: 'DELETE',
				data: data
			}
		}
	};
};

export const deleteHeader = (url, data) => {
	return {
		type: DELETE_HEADER,
		meta: {
			api: {
				url: url,
				method: 'DELETE',
				data: data
			}
		}
	};
};

export const addCustom = (url, data) => {
	return {
		type: CREATE_CUSTOM,
		meta: {
			api: {
				url: url,
				method: 'POST',
				data: data
			}
		}
	};
};

export const addCustomBody = (url, data) => {
	return {
		type: ADD_CUSTOM_BODY,
		meta: {
			api: {
				url: url,
				method: 'POST',
				data: data
			}
		}
	};
};

export const editSection = (url, data) => {
	return {
		type: EDIT_SECTION,
		meta: {
			api: {
				url: url,
				method: 'PUT',
				data: data
			}
		}
	};
};

export const editBody = (url, data) => {
	return {
		type: EDIT_BODY,
		meta: {
			api: {
				url: url,
				method: 'PUT',
				data: data
			}
		}
	};
};

export const editHeader = (url, data) => {
	return {
		type: EDIT_HEADER,
		meta: {
			api: {
				url: url,
				method: 'PUT',
				data: data
			}
		}
	};
};

export const submitIndependence = (url, data) => {
	return {
		type: SUBMIT_INDEPENDENCE,
		resolve: true,
		meta: {
			api: {
				url: url,
				method: 'PATCH',
				data: data
			}
		}
	};
};

export const clearProfileData = () => {
	return {
		type: CLEAR_PROFILE_DATA
	};
};

export const submitProfile = (engagementId, documentId, data) => {
	const url = `${env.getBaseURL(serviceURL, engagementId)}Forms/${documentId}/SubmitProfile`;

	return {
		type: SUBMIT_PROFILE,
		resolve: true,
		meta: {
			api: {
				url: url,
				method: 'PATCH',
				data: data
			}
		}
	};
};

export const submitIndependenceAction = (engagementId, userId, operationType, data) => {
	const url = env.getBaseURL(serviceURL, engagementId) + 'InternalUsers/' + userId + '/IndependenceAction?independenceAction=' + operationType;

	return {
		type: SUBMIT_INDEPENDENCE_ACTION,
		meta: {
			api: {
				url: url,
				method: 'PATCH',
				data: data
			}
		}
	};
};

export const submitIndependenceTemplate = (engagementId, documentId, requestBody = {}) => {
	const url = submitIndependenceTemplateUrl(engagementId, documentId);

	return {
		type: SUBMIT_INDEPENDENCE_TEMPLATE,
		meta: {
			api: {
				url: url,
				method: 'POST',
				data: requestBody
			}
		}
	};
};

export const overwriteForm = (url, data) => {
	return {
		type: OVERWRITE_FORM,
		meta: {
			api: {
				url: url,
				method: 'PATCH',
				data: data
			}
		}
	};
};

export function updateStoreForFormDataNoSaga(data) {
	return {
		type: UPDATE_RICH_TEXT_BODY,
		data: {
			id: data.id,
			bodyFreeText: data.isConflict ? data.currentBodyFreeText : data.bodyFreeText,
			concurrencyToken: data.concurrencyToken,
			isConflict: data.isConflict
		}
	};
}

export const updateBodyFreeText = (bodyId, bodyFreeText, bodyTypeId, concurrencyToken, discardChanges) => {
	return {
		type: UPDATE_BODY_FREE_TEXT,
		data: {
			id: bodyId,
			bodyFreeText: bodyFreeText,
			bodyTypeId: bodyTypeId,
			concurrencyToken: concurrencyToken,
			discardChanges: discardChanges
		}
	};
};

export const updateOnConflict = (bodyId, conflictResponse) => {
	return {
		type: UPDATE_BODY_ON_CONFLICT,
		data: {id: bodyId, conflictResponse: conflictResponse}
	};
};

export function updateFormBodyRelatedObject(data, operationType = OperationTypes.update) {
	return {
		type: UPDATE_FORM_BODY_RELATEOBJECTS_AFTER_RESPONSE,
		operationType,
		response: data
	};
}

export function updateFormBodyRelatedDocCount(id, relatedDocCount) {
	return {
		type: UPDATE_BODY_RELATED_COUNT,
		data: {id: id, relatedDocCount: relatedDocCount}
	};
}

export const createUserIndependenceForm = (url) => {
	return {
		type: CREATE_INDEPENDENCE_FORM,
		meta: {
			api: {
				url: url,
				method: 'POST',
				data: {documentTypeId: documentTypes.INDEPENDENCEFORMINDIVIDUAL}
			}
		}
	};
};

export function updateStoreForFormBodyRiskFactors(bodyId, riskId, riskCustomDescription) {
	return {
		type: UPDATE_FORMBODY_RISKFACTORS,
		bodyId: bodyId,
		riskId: riskId,
		riskCustomDescription: riskCustomDescription
	};
}

export function getFormBodyGuidances(engagementId, documentId, sectionId, bodyId, guidanceTypeIds = [], trackWithArea) {
	const query = guidanceTypeIds.reduce((acc, id) => {
		if (acc) {
			acc += '&';
		}

		return `${acc}filterGuidanceTypeIds=${id}`;
	}, '');

	let url = `${Env.getBaseURL(serviceURL, engagementId)}Forms/${documentId}/Body/${bodyId}/Guidances`;

	if (guidanceTypeIds.length > 0) {
		url += `?${query}`;
	}

	return {
		type: GET_BODY_GUIDANCES,
		meta: {
			api: {
				url,
				method: 'GET',
				trackWithArea
			}
		},
		sectionId,
		bodyId
	};
}

export const updateFormBodyDisplayData = (engagementId, documentId, bodyId, refreshDisplayConditions = true) => {
	return createApiReadAction(
		UPDATE_FORM_BODY_DISPLAY_DATA_ONLY,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.FORMS.FORMS]: documentId,
			[API_RESOURCES.FORMS.DISPLAYEDBODIES]: undefined
		},
		{refreshDisplayConditions},
		{bodyId}
	);
};

export const updateFormBodyRelatedDeficiency = (sectionId, bodyId, bodyOptionId, deficiency, isAdd) => {
	return {
		type: UPDATE_FORM_BODY_RELATED_DEFICIENCY,
		sectionId,
		bodyId,
		bodyOptionId,
		deficiency,
		isAdd
	};
};
